module.exports = __webpack_public_path__ + "img/cw.21d20d61.svg";